const allowedStoryboardFileTypes = [
  "image/jpg", 
  "image/jpeg", 
  "image/png",
  "video/mp4",
  "application/pdf",
  "application/msword", 
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
]

export default allowedStoryboardFileTypes
